import api from "../api/config";
import { ENDPOINTS } from "../api/endpoints";

export const submitMerchantForm = async (state, config, messageApi) => {
  try {
    // Map field keys to user-friendly names
    const fieldLabels = {
      firstName: "First Name",
      lastName: "Last Name",
      businessName: "Business Name",
      email: "Email Address",
      phoneNumber: "Phone Number",
    };

    const requiredFields = Object.keys(fieldLabels);
    const missingFields = requiredFields.filter(
      (field) => !state[field]?.trim()
    );

    if (missingFields.length > 0) {
      const errorMessage = `The following required fields are missing: ${missingFields
        .map((field) => fieldLabels[field])
        .join(", ")}. Please complete them before submitting the form.`;
      if (messageApi) {
        messageApi.error(errorMessage, 3);
      }
      throw new Error("Missing required fields");
    }
    
    // Validate file types
    const validateFileType = (file) => {
      return file && file.type !== "";
    };

    // Check if files are valid
    if (state.file) {
      if (Array.isArray(state.file)) {
        // Multiple files - check each file
        const invalidFiles = state.file.filter(file => !validateFileType(file));
        if (invalidFiles.length > 0) {
          if (messageApi) {
            messageApi.error("Some files have unknown or unsupported types. Please upload valid PDF, JPG, PNG, Excel (.xls, .xlsx), or CSV files.", 3);
          }
          throw new Error("Invalid file type");
        }
      } else {
        // Single file
        if (!validateFileType(state.file)) {
          if (messageApi) {
            messageApi.error("File type is unknown or not supported. Please upload a valid PDF, JPG, PNG, Excel (.xls, .xlsx), or CSV file.", 3);
          }
          throw new Error("Invalid file type");
        }
      }
    }
    
    const data = new FormData();
    
    // Handle multiple files for documents only
    if (state.file && Array.isArray(state.file)) {
      // Multiple files for documents
      state.file.forEach((file, index) => {
        data.append("file", file);
      });
    } else if (state.file) {
      // Single file
      data.append("file", state.file);
    }

    const params = {
      firstName: state.firstName.trim(),
      lastName: state.lastName.trim(),
      businessName: state.businessName.trim(),
      email: state.email.trim(),
      phoneNumber: state.phoneNumber.trim(),
      Gateway: state.Gateway.trim(),
      salesRep: state.salesRep.trim(),
      accountExecutive: state.accountExecutive.trim(),
      repEmail: state.repEmail.trim(),
      subRep: state.subRep.trim(),
      notes: state.notes.trim(),
      reason: state.reason.trim(),
      Lead_Source: config.hasCompanySelect ? state.company : config.title
    };

    if(config.partner) {
      params.partner = config.partner;
    }
    if (config.hasProjectedVolume) {
      params.projectedVolume = state.projectedVolume.trim();
    }
    if (config.hasLocation) {
      params.currency = state.currency;
    }
    if (config.hasRateQuote) {
      params.needsQuote = state.rateQuote;
    }
    const response = await api.post(ENDPOINTS.POST_ZOHO_LEADS_NEW_LEAD, data, {
      params,
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.data.success) {
      if (messageApi) {
        messageApi.success(response?.data.message || "Form submitted successfully!", 3);
      }
    } else {
      if (messageApi) {
        messageApi.error("Failed to submit merchant form", 3);
      }
    }

    return response;
  } catch (error) {
    // Handle validation errors
    if (error.response?.data?.errors.length > 0) {
      const validationErrors = error.response.data.errors;
      // Show only the first validation error
      if (messageApi) {
        messageApi.error(validationErrors[0].msg, 3);
      }
      throw new Error("Validation failed");
    }

    // Handle other errors
    console.error("Failed to submit merchant form. Please try again.");
    throw error;
  }
};
